    import React, { useState ,useEffect} from "react";
    import Select from "react-select";
    import axios from "axios";
    import tw from "twin.macro";
    import styled, { css, keyframes } from "styled-components";
    import { Toaster, toast } from 'react-hot-toast';
    import { useTranslation } from "react-i18next";
    import { SectionHeading, Subheading as SubheadingBase } from "../../../components/misc/Headings.js";
    const API_URL = "https://api.exchangerate-api.com/v4/latest/USD";


    const tariffs = {
        1: {
            standard: [10, 14, 21, 28, 35, 42, 14],
            express:  [12, 16, 23, 30, 37, 44, 16],
        },
        2: {
            standard: [11, 15, 22, 29, 36, 43, 15],
            express:  [13, 17, 24, 31, 38, 45, 17],
        },
        3: {
            standard: [12, 16, 23, 30, 37, 44, 16],
            express:  [14, 18, 25, 32, 39, 46, 18],
        },
    };


    const customStyles = {
        control: (base, state) => ({
            ...base,
            borderColor: state.isFocused ? "#0ABD19" : "#D1D5DB",
            boxShadow: state.isFocused ? "0 0 0 2px #A7F3D0" : "none",
            "&:hover": {
                borderColor: "#0ABD19",
            },
        }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected ? "#A7F3D0" : state.isFocused ? "#D1FAE5" : "white",
            color: state.isSelected ? "#065F46" : "#111827",
            "&:hover": {
                backgroundColor: "#D1FAE5",
                color: "#065F46",
            },
        }),
        dropdownIndicator: (base) => ({
            ...base,
            color: "#0ABD19",
            "&:hover": {
                color: "#065F46",
            },
        }),
        clearIndicator: (base) => ({
            ...base,
            color: "#0ABD19",
            "&:hover": {
                color: "#065F46",
            },
        }),
        singleValue: (base) => ({
            ...base,
            color: "#065F46",
        }),
        placeholder: (base) => ({
            ...base,
            color: "#6B7280",
        }),
    };
    const fadeIn = keyframes`
        from {
            opacity: 0;
            height: 0;
            transform: scaleY(0);
        }
        to {
            opacity: 1;
            height: auto;
            transform: scaleY(1);
        }
    `;

    const fadeOut = keyframes`
        from {
            opacity: 1;
            height: auto;
            transform: scaleY(1);
        }
        to {
            opacity: 0;
            height: 0;
            transform: scaleY(0);
        }
    `;

    const Wrapper = styled.div`
        max-width: 480px;
         /* Уменьшен отступ сверху */
    margin-left: 76px;
        padding: 25px;
        background-color: #ffffff;
        border-radius: 16px;
        border: 2px solid #0ABD19;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
        font-family: Arial, sans-serif;
        position: relative;
    `;


    const Title = tw(
        SectionHeading
    )`font-black text-3xl sm:text-2xl lg:text-2xl text-center leading-tight mb-4 `;


    const CountrySwitcher = styled.div`
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
        background-color: #f7f7f7;
        border-radius: 10px;
        padding: 5px;
    `;

    const CountryButton = styled.button`
        flex: 1;
        padding: 12px 0;
        font-size: 16px;
        font-weight: bold;
        border: none;
        border-radius: 8px;
        background-color: ${(props) => (props.active ? "#0ABD19" : "#ffffff")};
        color: ${(props) => (props.active ? "#ffffff" : "#0ABD19")};
        cursor: pointer;
        transition: background-color 0.3s, color 0.3s;
    
        &:hover {
            background-color: ${(props) => (props.active ? "#36cf62" : "#d1fae5")};
            color: #065f46;
        }
    
        &:not(:last-child) {
            margin-right: 5px;
        }
    `;

    const ToggleContainer = styled.div`
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 17px;
    `;

    const ToggleLabel = styled.label`
        font-size: 16px;
        color: #333;
    `;

    const ToggleSwitch = styled.input`
        appearance: none;
        width: 40px;
        height: 20px;
        background: #ccc;
        border-radius: 10px;
        position: relative;
        cursor: pointer;
        outline: none;
        transition: background 0.3s;
    
        &:checked {
            background: #34c759;
        }
    
        &::before {
            content: '';
            position: absolute;
            top: 2px;
            left: 2px;
            width: 16px;
            height: 16px;
            background: white;
            border-radius: 50%;
            transition: transform 0.3s;
        }
    
        &:checked::before {
            transform: translateX(20px);
        }
    `;

    const Form = styled.form`
        display: flex;
        flex-direction: column;
        gap: 15px;
    `;

    const Row = styled.div`
        display: flex;
        gap: 10px;
        flex-wrap: nowrap; /* отключено оборачивание */
        justify-content: space-between;
        align-items: center; /* выравнивание по вертикали */
        ${(props) =>
                props.animate &&
                css`
                    animation: ${props.visible ? fadeIn : fadeOut} 0.3s ease forwards;
                `}
    `;


    const Input = styled.input`
        flex: 1;
        min-width: 48%;
        height: 40px; /* добавлено */
        padding: 10px;
        border: 1px solid #ccc;
        border-radius: 6px;
        font-size: 16px;

        &:focus {
            border-color: #34c759;
            box-shadow: 0 0 5px rgba(52, 199, 89, 0.3);
        }
    `;


    const Button = styled.button`
      background-color: #34c759;
      color: white;
      padding: 15px;
      font-size: 18px;
      font-weight: bold;
      border: none;
      border-radius: 8px;
      cursor: pointer;
    
      &:hover {
        background-color: #2a9d4d;
      }
    `;

    const Result = styled.div`
      margin-top: 20px;
      text-align: center;
      font-size: 24px;
      color: #333;
    
      strong {
        color: #34c759;
        font-size: 24px;
      }
    `;
    const AnimatedWrapper = styled.div`
        overflow: hidden;
        ${(props) =>
                props.animate &&
                css`
                    animation: ${props.visible ? fadeIn : fadeOut} 0.3s ease forwards;
                `}
    `;
    const SelectStyled = styled.select`
  flex: 1;
  height: 40px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 16px;
  background-color: #fff;
  color: #333;

  &:focus {
    border-color: #34c759;
    box-shadow: 0 0 5px rgba(52, 199, 89, 0.3);
    outline: none;
  }
`;

    function Calculator() {

        const { t } = useTranslation();

        const citiesOpts = [
            { value: "Almaty", label: t("cities.almaty"), zone: 1 },
            { value: "Astana", label: t("cities.astana"), zone: 2 },
            { value: "Balkhash", label: t("cities.balkhash"), zone: 2 },
            { value: "Shymkent", label: t("cities.shymkent"), zone: 2 },
            { value: "Karaganda", label: t("cities.karaganda"), zone: 2 },
            { value: "Kosshy", label: t("cities.kosshy"), zone: 2 },
            { value: "Aktobe", label: t("cities.aktobe"), zone: 3 },
            { value: "Pavlodar", label: t("cities.pavlodar"), zone: 3 },
            { value: "Semey", label: t("cities.semey"), zone: 3 },
            { value: "Ust-Kamenogorsk", label: t("cities.ustKamenogorsk"), zone: 3 },
            { value: "Shemonaikha", label: t("cities.shemonaikha"), zone: 3 },
            { value: "Atyrau", label: t("cities.atyrau"), zone: 3 },
            { value: "Kostanay", label: t("cities.kostanay"), zone: 2 },
            { value: "Taraz", label: t("cities.taraz"), zone: 2 },
            { value: "Oral", label: t("cities.oral"), zone: 3 },
            { value: "Kyzylorda", label: t("cities.kyzylorda"), zone: 3 },
            { value: "Aktau", label: t("cities.aktau"), zone: 3 },
            { value: "Taldykorgan", label: t("cities.taldykorgan"), zone: 1 },
            { value: "Zhezkazgan", label: t("cities.zhezkazgan"), zone: 2 },
            { value: "Zhitikara", label: t("cities.zhitikara"), zone: 2 },
            { value: "Petropavlovsk", label: t("cities.petropavlovsk"), zone: 2 },
            { value: "Turkestan", label: t("cities.turkestan"), zone: 2 },
            { value: "Ekibastuz", label: t("cities.ekibastuz"), zone: 3 },
            { value: "Rudny", label: t("cities.rudny"), zone: 2 },
            { value: "Temirtau", label: t("cities.temirtau"), zone: 2 },
            { value: "Kokshetau", label: t("cities.kokshetau"), zone: 2 },
            { value: "Stepnogorsk", label: t("cities.stepnogorsk"), zone: 2 },
            { value: "Tayynsha", label: t("cities.tayynsha"), zone: 2 },
            { value: "Tobyl", label: t("cities.tobyl"), zone: 2 },
            { value: "Altai", label: t("cities.altai"), zone: 3 },
            { value: "Shchuchinsk", label: t("cities.shchuchinsk"), zone: 2 },
            { value: "Saryagash", label: t("cities.saryagash"), zone: 2 },
            { value: "Zhanaozen", label: t("cities.zhanaozen"), zone: 3 },
            { value: "Satpayev", label: t("cities.satpayev"), zone: 2 },
            { value: "Shakhtinsk", label: t("cities.shakhtinsk"), zone: 2 },
            { value: "Abay", label: t("cities.abay"), zone: 1 },
            { value: "Besagash", label: t("cities.besagash"), zone: 1 },
            { value: "Boraldai", label: t("cities.boraldai"), zone: 1 },
            { value: "Kaskelen", label: t("cities.kaskelen"), zone: 1 },
            { value: "Otegen-Batyr", label: t("cities.otegenBatyr"), zone: 1 },
            { value: "Ridder", label: t("cities.ridder"), zone: 3 },
            { value: "Zyryanovsk", label: t("cities.zyryanovsk") }, // зона не указана в оригинале
            { value: "Lisakovsk", label: t("cities.lisakovsk"), zone: 2 },
            { value: "Novoishimskoe", label: t("cities.novoishimskoe"), zone: 2 },
            { value: "Esik", label: t("cities.esik"), zone: 1 },
            { value: "Konaev", label: t("cities.konaev"), zone: 1 },
            { value: "Korday", label: t("cities.korday"), zone: 1 },
            { value: "Talgar", label: t("cities.talgar"), zone: 1 },
            { value: "Tuzdybastau", label: t("cities.tuzdybastau"), zone: 1 },
            { value: "Aksay", label: t("cities.aksay"), zone: 3 },
            { value: "Lenger", label: t("cities.lenger"), zone: 2 },
            { value: "Priozersk", label: t("cities.priozersk"), zone: 2 },
            { value: "Saran", label: t("cities.saran"), zone: 2 },
            { value: "Kandyagash", label: t("cities.kandyagash") }, // зона не указана в оригинале
            { value: "Atbasar", label: t("cities.atbasar"), zone: 2 }
        ];

        const [city, setCity] = useState(null);
        const [weight, setWeight] = useState("");
        const [length, setLength] = useState("");
        const [width, setWidth] = useState("");
        const [height, setHeight] = useState("");
        const [deliveryMethod, setDeliveryMethod] = useState("standard");


        const [showDimensions, setShowDimensions] = useState(false);
        const [deliveryCost, setDeliveryCost] = useState(null);
        const [currency, setCurrency] = useState("USD");
        const [exchangeRates, setExchangeRates] = useState({});
        const [country, setCountry] = useState("USA");
        // Получаем курс валют при загрузке страницы
        useEffect(() => {
            axios
                .get(API_URL)
                .then((response) => setExchangeRates(response.data.rates))
                .catch((error) => console.error("Ошибка загрузки курса валют:", error));
        }, []);

        const calculateDeliveryCost = (event) => {
            event.preventDefault();
            if (!city || !weight) {
                toast.error("Выберите город и введите вес!");
                return;
            }

            const zone = city.zone;
            const weightNum = parseFloat(weight);

            if (weightNum <= 0) {
                toast.error("Введите корректный вес!");
                return;
            }

            const methodTariffs = tariffs[zone]?.[deliveryMethod];

            if (!methodTariffs) {
                toast.error("Нет тарифов для выбранной зоны или метода доставки.");
                return;
            }

            let cost;
            if (weightNum <= 0.5) cost = methodTariffs[0];
            else if (weightNum <= 1) cost = methodTariffs[1];
            else if (weightNum <= 1.5) cost = methodTariffs[2];
            else if (weightNum <= 2) cost = methodTariffs[3];
            else if (weightNum <= 2.5) cost = methodTariffs[4];
            else if (weightNum <= 3) cost = methodTariffs[5];
            else cost = methodTariffs[6] * (Math.ceil(weightNum) - 3) + methodTariffs[5];

            const rate = exchangeRates[currency] || 1;
            const convertedCost = cost / rate;

            setDeliveryCost(isNaN(convertedCost) ? 0 : convertedCost);
        };


        const deliveryMethods = [
            { value: "standard", label: "ПВЗ" },
            // { value: "express", label: "Курьер" },
        ];


        return  (

            <Wrapper>
                <Title>{t("calculator.title")}</Title>

                <CountrySwitcher>
                    <CountryButton active={country === "USA"} onClick={() => setCountry("USA")}>
                        {t("calculator.fromUsa")}
                    </CountryButton>
                </CountrySwitcher>

                <ToggleContainer>
                    <ToggleLabel>{t("calculator.specifyDimensions")}</ToggleLabel>
                    <ToggleSwitch
                        type="checkbox"
                        checked={showDimensions}
                        onChange={() => setShowDimensions(!showDimensions)}
                    />
                </ToggleContainer>

                <Form onSubmit={calculateDeliveryCost}>
                    <Row>
                        <Select
                            options={deliveryMethods}
                            value={deliveryMethods.find(m => m.value === deliveryMethod)}
                            onChange={(o) => setDeliveryMethod(o.value)}
                            placeholder={t("calculator.chooseDeliveryMethod")}
                            styles={customStyles}
                        />
                        <Input
                            type="text"
                            placeholder={country === "Turkey" ? t("calculator.soon") : t("calculator.weight")}
                            value={country === "Turkey" ? "" : weight}
                            onChange={(e) => setWeight(e.target.value)}
                            disabled={country === "Turkey"}
                        />

                    </Row>

                    {showDimensions && (
                        <>
                            <Row animate visible={showDimensions}>
                                <Input type="number" placeholder={t("calculator.length")} value={length} onChange={(e)=>setLength(e.target.value)} />
                                <Input type="number" placeholder={t("calculator.width")}  value={width}  onChange={(e)=>setWidth(e.target.value)} />
                            </Row>
                            <Row animate visible={showDimensions}>
                                <Input type="number" placeholder={t("calculator.height")} value={height} onChange={(e)=>setHeight(e.target.value)} />
                            </Row>
                        </>
                    )}

                    <Select
                        options={citiesOpts}
                        value={city}
                        onChange={(opt) => setCity(opt)}
                        placeholder={country === "Turkey" ? t("calculator.soon") : t("calculator.chooseCity")}
                        isClearable
                        isDisabled={country === "Turkey"}
                        noOptionsMessage={() => t("calculator.cityNotFound")}
                        styles={customStyles}
                    />

                    <Row>
                        <SelectStyled value={currency} onChange={(e)=>setCurrency(e.target.value)}>
                            <option value="USD">USD</option>
                            <option value="EUR">EUR</option>
                            <option value="TRY">TRY</option>
                        </SelectStyled>
                    </Row>

                    <Button type="submit">{t("calculator.calculate")}</Button>
                </Form>

                {deliveryCost !== null && country !== "Turkey" && (
                    <Result>
                        {t("calculator.deliveryCost")}: <strong>{Number(deliveryCost).toFixed(2)} {currency}</strong>
                    </Result>
                )}

                {country === "Turkey" && (
                    <Result><strong>{t("calculator.soon")}</strong></Result>
                )}
            </Wrapper>

        );
    }

    export default Calculator;
